// Copyright (c) StrangeBee 2023

import { QuerySelector } from 'thehive-sdk';

interface ComputeGetSelector {
    observableId: string;
    extraData?: string[];
}

export const computeGetSelector = ({
    observableId,
    extraData = ['permissions'],
}: ComputeGetSelector): QuerySelector => ({
    head: [
        {
            name: 'getObservable',
            idOrName: observableId,
        },
    ],
    extraData,
    name: `get-observable-${observableId}`,
});

interface ComputeListSelector {
    caseId: string;
}

export const computeListSelector = ({ caseId }: ComputeListSelector): QuerySelector => ({
    head: [{ name: 'getCase', idOrName: caseId }, { name: 'observables' }],
    extraData: ['seen', 'permissions', 'shareCount'],
    name: `get-case-observables-${caseId}`,
    sort: ['-startDate'],
});

interface ComputeAlertListSelector {
    alertId: string;
}

export const computeAlertListSelector = ({ alertId }: ComputeAlertListSelector): QuerySelector => ({
    head: [{ name: 'getAlert', idOrName: alertId }, { name: 'observables' }],
    extraData: ['seen'],
    name: 'get-alert-observables',
    sort: ['-startDate'],
});
